import { Annotation, Concept, Data, Region, User, Worker } from 'clarifai-web-grpc/proto/clarifai/api/resources_pb';

export const createAnnotationWithRegionAndConcept = (conceptItem: Concept, annotationItem: Annotation, userOrOrgId: string): Annotation => {
  // Initialize a new Annotation instance
  const annotation = new Annotation();
  annotation.setInputId(annotationItem?.getInputId() as string);
  const user = new User();
  const worker = new Worker();
  user.setId(userOrOrgId);
  worker.setUser(user);
  annotation.setWorker(worker);

  const annotationData = new Data();
  const region = new Region();
  const regionData = new Data();
  const regionsList = annotationItem?.getData()?.getRegionsList();
  if (Array.isArray(regionsList) && regionsList.length > 0) {
    region.setRegionInfo(regionsList[0].getRegionInfo());
  }

  regionData.addConcepts(conceptItem);

  region.setData(regionData);
  annotationData.addRegions(region);

  annotation.setData(annotationData);

  return annotation;
};
